import React, { useState } from "react";

const Menu = (props) => {
  const [selectedLink, setSelectedLink] = useState(
    props.selectedLink == null || props.selectedLink == ""
      ? { title: "" }
      : props.selectedLink
  );

  const linkChanged = (item) => {
    // alert(item);
    setSelectedLink(item.fields.title);
    if (props.onChange != null) props.onChange(item);
    //alert(item);
  };

  return (
    <div>
      <ul>
        {props.links != null &&
          props.links.map((item) => {
            return (
              <li
                className={`items_full_width ${selectedLink == item.fields.title ? "current-menu-item" : ""
                  }`}
                id="cursor_dot"
                onClick={() => linkChanged(item)}
                style={{ lineHeight: "0.75", width: '100%' }}
              >
                {item.fields.title.split(" ")[0]}
                {item.fields.title.split(" ")[1] != null && (<>


                  <br /> {item.fields.title.split(" ")[1]}
                </>
                )}
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default Menu;
